import { render } from "./ConfirmDeleteFavoriteModal.vue?vue&type=template&id=2212f944&scoped=true"
import script from "./ConfirmDeleteFavoriteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteFavoriteModal.vue?vue&type=script&lang=js"

import "./ConfirmDeleteFavoriteModal.vue?vue&type=style&index=0&id=2212f944&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2212f944"]])

export default __exports__